module.exports = __webpack_public_path__ + "static/bg-header-math-calculators-843f3e86b2065f3e2118964b596dd450.svg";